module.exports = __webpack_public_path__ + "static/addict-logo-1aa184b72402c3328eac28070b4f062d.svg";